__turbopack_context__.v({
  "count": "CardHeader-module-scss-module__uBodFW__count",
  "description": "CardHeader-module-scss-module__uBodFW__description",
  "label": "CardHeader-module-scss-module__uBodFW__label",
  "mobileHeader": "CardHeader-module-scss-module__uBodFW__mobileHeader",
  "titleContent": "CardHeader-module-scss-module__uBodFW__titleContent",
  "titleRow": "CardHeader-module-scss-module__uBodFW__titleRow",
});
